import { Button } from '@/components/ui/Button'
import { EmptyState } from '@/components/ui/EmptyState'
import { formatDateTime } from '@/lib/venue/format'
import type { VenueReservationSettingHistoryItem } from '@/lib/venue/reservationSettingTypes'
import { reservationHistoryTransitionText } from '@/lib/venue/reservationSettingViewModel'

/**
 * 변경 이력 표 + "더 보기"(이슈 "변경 이력(변경 일시, ON→OFF/OFF→ON, 처리자)을 최신순 조회").
 *
 * 🔒 처리자 컬럼은 `actorTypeLabel` 만 보여준다 — `actorRefId` 는 표시명이 아닌 식별자라 화면에
 * 원문 그대로 노출하지 않는다(#757 §3, #758 자율 결정 7).
 */
export function ReservationSettingHistoryTable({
  items,
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
}: {
  items: VenueReservationSettingHistoryItem[]
  hasNextPage: boolean
  isFetchingNextPage: boolean
  onLoadMore: () => void
}) {
  if (items.length === 0) {
    return <EmptyState title="변경 이력이 없습니다" />
  }

  return (
    <div className="space-y-3">
      <div className="overflow-x-auto rounded-xl border border-slateish-200">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="border-b border-slateish-200 bg-slateish-50 text-left text-xs font-medium text-slateish-600">
              <th className="px-3 py-2">변경 일시</th>
              <th className="px-3 py-2">전환 내용</th>
              <th className="px-3 py-2">처리자</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id} className="border-b border-slateish-100 last:border-b-0">
                <td className="px-3 py-2 text-ink-700">{formatDateTime(item.changedAt)}</td>
                <td className="px-3 py-2 text-ink-700">{reservationHistoryTransitionText(item)}</td>
                <td className="px-3 py-2 text-slateish-600">{item.actorTypeLabel}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {hasNextPage ? (
        <div className="flex justify-center">
          <Button variant="secondary" size="sm" disabled={isFetchingNextPage} onClick={onLoadMore}>
            {isFetchingNextPage ? '불러오는 중…' : '더 보기'}
          </Button>
        </div>
      ) : null}
    </div>
  )
}
